'use client'

import { useSelectedLayoutSegment } from 'next/navigation'

export function HeaderBarBackground() {
  const segment = useSelectedLayoutSegment()

  return segment && segment !== 'buy' ? <div className="relative inset-0 z-0 h-16 bg-neutral-850 md:h-24" /> : null
}
